define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var collectionMarketAdminRoles = ['CM Master Administrator'];
	var collectionMarketLookAdminRoles = ['CM Look Administrator'];
	var salesMarketAdminRoles = ['CM Sales Market Administrator'];

	csiAccess.addViewRoles({
		"_CS_ApparelViews":{
			"MarketingCollections":{
				"CMMakeUnavailable":access(full(collectionMarketAdminRoles)),
				"NewMarketingCollection":access(full(collectionMarketAdminRoles)),
				"CMReleaseToCustomers":access(full(collectionMarketAdminRoles)),
				"CMReleaseToMarkets":access(full(collectionMarketAdminRoles)),
				"CMReturnToDraft":access(full(collectionMarketAdminRoles))
			},
			"MarketingLooks":{
				"NewMarketingLook":access(full(collectionMarketLookAdminRoles)),
				"CMMakeUnavailable":access(full(collectionMarketLookAdminRoles)),
				"CMReleaseToCustomers":access(full(collectionMarketLookAdminRoles)),
				"CMReleaseToMarkets":access(full(collectionMarketLookAdminRoles)),
				"CMReturnToDraft":access(full(collectionMarketLookAdminRoles))
			},
			"MarketingTools":{
				"NewMarketingTool":access(full(collectionMarketAdminRoles))
			},
			"SalesMarkets":{
				"NewSalesMarket":access(full(salesMarketAdminRoles))
			}
		},

		"MarketingCollection":{
			"SalesCollections":{
				"PushProductsToSalesMarket":access(full(collectionMarketAdminRoles))
			},
			"StateHeader":{
				"CMMakeUnavailable":access(full(collectionMarketAdminRoles)),
				"CMReleaseToCustomers":access(full(collectionMarketAdminRoles)),
				"CMReleaseToMarkets":access(full(collectionMarketAdminRoles)),
				"CMReturnToDraft":access(full(collectionMarketAdminRoles))
			}
		},

		"MarketingLook":{
			"SalesLooks":{
				"PushProductsToSalesMarket":access(full(collectionMarketLookAdminRoles))
			},
			"StateHeader":{
				"CMMakeUnavailable":access(full(collectionMarketLookAdminRoles)),
				"CMReleaseToCustomers":access(full(collectionMarketLookAdminRoles)),
				"CMReleaseToMarkets":access(full(collectionMarketLookAdminRoles)),
				"CMReturnToDraft":access(full(collectionMarketLookAdminRoles))
			}
		},

		"MCProduct":{
			"StateHeader":{
				"CMMakeUnavailable":access(full(collectionMarketAdminRoles)),
				"CMReleaseToCustomers":access(full(collectionMarketAdminRoles)),
				"CMReleaseToMarkets":access(full(collectionMarketAdminRoles)),
				"CMReturnToDraft":access(full(collectionMarketAdminRoles))
			}
		}
	});
});